import {
  useExportCsv,
  useExportXlsx,
} from '@/features/InvoiceReport/Edit/components/InvoiceTransaction/hooks/useExport';
import {
  InvoiceTransaction,
  TransactionProperty,
} from '@/features/InvoiceReport/Edit/type';
import {
  ActionMenu,
  ActionMenuItems,
  ButtonV2,
  ButtonV2Props,
  IconTrailing,
} from '@moneyforward/ap-frontend-components';
import { FC, memo, Suspense, useMemo } from 'react';

export type Props = {
  watchFields: InvoiceTransaction[];
  includeTax: boolean;
  showColumnDetails: boolean;
  isApproverRoleFromPath: boolean;
  hasWithholdingIncomeTax: boolean;
  canDisplayDrExcise: boolean;
  transactionProperties?: TransactionProperty[];
};

const InnerExportAction: FC<Props> = memo(
  ({
    watchFields,
    includeTax,
    showColumnDetails,
    isApproverRoleFromPath,
    hasWithholdingIncomeTax,
    canDisplayDrExcise,
    transactionProperties = [],
  }) => {
    const { onExportsSjisCsv, onExportsUtf8Csv } = useExportCsv({
      fields: watchFields,
      taxInclude: includeTax,
      invoiceTransactionDetails: showColumnDetails,
      isAdminOrApproval: isApproverRoleFromPath,
      hasWithholdingIncomeTax,
      canDisplayDrExcise,
      transactionProperties,
    });
    const { onExportsXlsx } = useExportXlsx({
      fields: watchFields,
      taxInclude: includeTax,
      invoiceTransactionDetails: showColumnDetails,
      isAdminOrApproval: isApproverRoleFromPath,
      hasWithholdingIncomeTax,
      canDisplayDrExcise,
      transactionProperties,
    });

    const exportsItems: ActionMenuItems = useMemo(() => {
      return [
        {
          key: 'sjis_export',
          label: 'Shift_JIS',
          onClick: onExportsSjisCsv,
        },
        {
          key: 'utf-8_export',
          label: 'UTF-8',
          onClick: onExportsUtf8Csv,
        },
        {
          key: 'excel_export',
          label: 'Excel形式',
          onClick: onExportsXlsx,
        },
      ];
    }, [onExportsSjisCsv, onExportsUtf8Csv, onExportsXlsx]);
    const actionButtonProps: ButtonV2Props = useMemo(
      () => ({
        children: 'エクスポート',
        color: 'primary',
        isSecondary: true,
        isTertiary: true,
        rightIcon: <IconTrailing size={16} />,
        isLoading: false,
      }),
      []
    );
    return (
      <ActionMenu
        type='button'
        items={exportsItems}
        buttonProps={actionButtonProps}
      />
    );
  }
);
InnerExportAction.displayName = 'InnerExportAction';

export const ExportAction: FC<Props> = memo((props) => {
  return (
    <Suspense fallback={<ButtonV2 isLoading />}>
      <InnerExportAction {...props} />
    </Suspense>
  );
});
ExportAction.displayName = 'ExportAction';
